import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { selectUsersOptions } from 'store/users/selectors';

import { wrapperClassname } from './LoanActionItem.constants';
import { DynamicValueInput } from './LoanActionItems';

const LoanActionAssignAeRow = ({ index, rootPath, isDisabled, isEditAllowed }) => {
  const usersOptions = useSelector(selectUsersOptions(null));

  const fieldPath = `${rootPath}[${index}]`;

  return (
    <div className={wrapperClassname}>
      <DynamicValueInput
        required
        disabled={isDisabled || !isEditAllowed}
        label="Account Executive"
        name={`${fieldPath}.aeUser`}
        options={usersOptions}
        type={FieldTypesEnum.SELECT}
      />
    </div>
  );
};

LoanActionAssignAeRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
};

export default memo(LoanActionAssignAeRow);
